angular.module('impactx.MenuDirectives').controller('MessageTodoDialogCtrl', ['$scope', '$mdDialog', 'dataGen', '$context', '$redirect', 'MessageService', MessageTodoDialogCtrl]);

function MessageTodoDialogCtrl($scope, $mdDialog, dataGen, $context, $redirect, MessageService) {
    $scope.customerServiceUserShown = $context.customerServiceUser.value;

    dataGen.getData($scope, {}, "/message/overview/todo", null, true).then(function () {
        var data = $scope.data;
        if (data !== null && data !== undefined) {
            $scope.messages = data.messages;
        }
    });

    $scope.hide = function() {
        $mdDialog.hide();
    };
    $scope.goToMessageTodoList = function() {
        $redirect.redirectTo(null, '/messagetodolist');
        $scope.hide();
    };

    $scope.goToDetailPage = function(id) {
        $redirect.redirectTo(null, '/message/' + id);
        $scope.hide();
    };

    $scope.followMessageLink = function (message) {
        if (message.route) {
            var dataObj = {
                ids: [message.id]
            };
            dataGen.postAsForm({}, dataObj, '/message/markread').then(function () {
                $redirect.redirectTo(null, message.route);
                $scope.hide();
            });
        }
    };

    $scope.canSendMessage = function () {
        return MessageService.canSendMessage();
    };
}